import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Equipment } from 'src/app/bo/equipment';
import { DRILL_TYPE_NAMES, EquipmentType } from 'src/app/bo/equipmentType';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-equipments-modale',
  templateUrl: './equipments-modale.component.html',
  styleUrls: ['./equipments-modale.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslateModule, ModalModule],
})
export class EquipmentsModaleComponent {
  readonly dataEmitter = new Subject<Equipment>();

  readonly bsModalRef = inject(BsModalRef);
  private readonly http = inject(HttpService);
  private readonly fonctionsService = inject(FonctionsService);

  // Propriétés assignées via initialState de ngx-bootstrap (pas des signals)
  equipment: Equipment;
  estModif = false;
  siteId: number = undefined;
  equipmentTypes: EquipmentType[] = [];

  protected readonly showError = signal(false);

  isDrillType(): boolean {
    if (!this.equipment?.typeId || !this.equipmentTypes?.length) {
      return false;
    }
    const typeId = Number(this.equipment.typeId);
    const selectedType = this.equipmentTypes.find(t => t.typeId === typeId);
    const name = selectedType?.name?.toUpperCase();
    return DRILL_TYPE_NAMES.includes(name);
  }

  showModalCancel(): void {
    this.bsModalRef.hide();
  }

  hideModalCancel(): void {
  }

  showConfirmSuppr(): void {
  }

  hideConfirmSuppr(): void {
  }

  onSubmit(): void {
    if (!this.equipment.name) {
      this.showError.set(true);
      setTimeout(() => {
        this.showError.set(false);
      }, 1000);
      return;
    }

    if (this.estModif) {
      this.onUpdate();
      return;
    }

    this.equipment.siteId = this.siteId;
    this.http.post<Equipment, Equipment>('Sites/' + this.siteId + '/Equipment', this.equipment).subscribe({
      next: (created) => {
        this.dataEmitter.next(created ?? this.equipment);
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
        this.bsModalRef.hide();
      }
    });
  }

  onUpdate(): void {
    this.equipment.siteId = this.siteId;
    this.equipment.typeId = Number(this.equipment.typeId);

    this.http.put('Sites/' + this.siteId + '/Equipment', this.equipment).subscribe({
      next: () => {
        this.dataEmitter.next(this.equipment);
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
        this.bsModalRef.hide();
      }
    });
  }

  onDelete(): void {
  }
}
